import { render, staticRenderFns } from "./fileSelector.vue?vue&type=template&id=01d36c2f&scoped=true&"
import script from "./fileSelector.vue?vue&type=script&lang=js&"
export * from "./fileSelector.vue?vue&type=script&lang=js&"
import style0 from "./fileSelector.vue?vue&type=style&index=0&id=01d36c2f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d36c2f",
  null
  
)

export default component.exports